import type { CheckboxProps } from '@mantine/core';
import { Checkbox } from '@mantine/core';
import { CheckIcon } from '@zenos/front-end-ui-icons';
import classNames from './Checkbox.module.css';

export default Checkbox.extend({
  defaultProps: { radius: 'sm', icon: CheckIcon as CheckboxProps['icon'] },
  classNames,
});
